(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-revenda-form"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pb-revenda-form')) {
    customElements.define(
      'pb-revenda-form',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          if (!this.form || !this.form.querySelector('[required]')) return;
          this.form.noValidate = true;
          this.form.addEventListener('input', (event) => this.onInput(event));
          this.form.addEventListener('change', (event) => this.check(event.target));
          this.form.addEventListener('focusout', (event) => {
            if (event.target.value) this.check(event.target);
          });
          this.form.addEventListener('submit', (event) => this.onSubmit(event));
        }

        onInput(event) {
          const field = event.target;
          const mask = field.dataset.mask;
          if (mask) {
            const value = mask === 'cnpj' ? this.cnpjMask(field.value) : this.numberMask(field.value, mask);
            if (value !== field.value) field.value = value;
          }
          if (field.getAttribute('aria-invalid') === 'true') this.check(field);
        }

        numberMask(raw, mask) {
          const d = raw.replace(/\D/g, '');
          if (mask === 'cep') return d.slice(0, 8).replace(/^(\d{5})(\d)/, '$1-$2');
          const n = d.slice(0, 11);
          if (n.length <= 2) return n.length ? `(${n}` : '';
          const split = n.length === 11 ? 7 : 6;
          return `(${n.slice(0, 2)}) ${n.slice(2, split)}${n.length > split ? '-' + n.slice(split) : ''}`;
        }

        // CNPJ alfanumérico (a partir de 2026): 12 primeiros caracteres em [0-9A-Z], dígitos verificadores numéricos
        cnpjMask(raw) {
          const c = raw.toUpperCase().replace(/[^0-9A-Z]/g, '').slice(0, 14);
          return c
            .replace(/^(.{2})(.)/, '$1.$2')
            .replace(/^(.{2})\.(.{3})(.)/, '$1.$2.$3')
            .replace(/^(.{2})\.(.{3})\.(.{3})(.)/, '$1.$2.$3/$4')
            .replace(/^(.{2})\.(.{3})\.(.{3})\/(.{4})(.)/, '$1.$2.$3/$4-$5');
        }

        cnpjValid(raw) {
          const c = raw.toUpperCase().replace(/[^0-9A-Z]/g, '');
          if (!/^[0-9A-Z]{12}\d{2}$/.test(c) || /^(.)\1{13}$/.test(c)) return false;
          const dv = (base) => {
            let weight = base.length - 7;
            let sum = 0;
            for (const ch of base) {
              sum += (ch.charCodeAt(0) - 48) * weight;
              weight = weight === 2 ? 9 : weight - 1;
            }
            const r = sum % 11;
            return r < 2 ? 0 : 11 - r;
          };
          const d1 = dv(c.slice(0, 12));
          const d2 = dv(c.slice(0, 12) + d1);
          return c.endsWith(`${d1}${d2}`);
        }

        check(field) {
          if (!field.name || !field.willValidate) return true;
          field.setCustomValidity('');
          if (field.dataset.mask === 'cnpj' && field.value && !this.cnpjValid(field.value)) {
            field.setCustomValidity('CNPJ inválido. Confira os números.');
          }
          const ok = field.checkValidity();
          const error = document.getElementById(`${field.id}-erro`);
          if (ok) {
            field.removeAttribute('aria-invalid');
          } else {
            field.setAttribute('aria-invalid', 'true');
          }
          if (!error) return ok;
          if (ok) error.textContent = '';
          else error.textContent = field.validity.customError ? field.validationMessage : field.dataset.msg || field.validationMessage;
          return ok;
        }

        onSubmit(event) {
          const fields = Array.from(this.form.elements).filter((el) => el.willValidate);
          const invalid = fields.filter((field) => !this.check(field));
          if (invalid.length) {
            event.preventDefault();
            invalid[0].focus();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
